
          import "CloseButton.styles_hejbpp.linaria.css";
          import { styled } from "@linaria/react";
import { Close as CloseIcon } from "../../icons";
const CloseButton = /*#__PURE__*/styled("button")({
  name: "CloseButton",
  class: "cravoj4"
});
export { CloseButton, CloseIcon };
          